
export const getC = async (id) =>{
    return 'a';
}

export const delay = (time) =>{
    return new Promise(resolve => setTimeout(resolve, time));
}
